import React from 'react';
import PropTypes from 'prop-types';

class Prompt extends React.PureComponent {
    static propTypes = {
        extraClassNames: PropTypes.string,
        model: PropTypes.object,
        questionModel: PropTypes.object,
        firstOrderNumber: PropTypes.number,
        orderNumber: PropTypes.string,
        isActive: PropTypes.bool,
        isFlagged: PropTypes.bool,
        groupId: PropTypes.string,
    };

    getOrderNumber() {
        const { orderNumber, firstOrderNumber, isActive, isFlagged, questionModel } = this.props;
        if (orderNumber) {
            const styles = ['order-number'];
            if (isActive) {
                styles.push('active');
            }
            if (isFlagged) {
                styles.push('flagged');
            }

            return (
                <span
                    className={styles.join(' ')}
                    id={`scorableItem-${questionModel.contentRevisionId}_${firstOrderNumber}`}
                >
                    {orderNumber}
                </span>
            );
        }
        return null;
    }

    render() {
        const { extraClassNames, model: { content, isRichText }, groupId } = this.props;
        const orderNumber = this.getOrderNumber();

        if (content === '' && !orderNumber) {
            return null;
        }

        let className = extraClassNames ? `interaction-prompt ${extraClassNames}` : 'interaction-prompt';
        if (isRichText) {
            className += ' rich-text-prompt';
        }

        return (
            <p className={className} id={groupId}>
                {orderNumber}
                {
                    content !== '' &&
                        <span className="text" dangerouslySetInnerHTML={{ __html: content }} />
                }
            </p>
        );
    }
}

export default Prompt;
